import { useSelectedLinkContext, useWebUserContext } from "contexts";
import VideoCallPage from "./VideoCallPage";

const VideoCallPageWithContext = (): JSX.Element => {
  const { webUser } = useWebUserContext();
  const { selectedLink } = useSelectedLinkContext();

  return (<VideoCallPage externalUsername={webUser.firstName} selectedLink={selectedLink} />)
}

export default VideoCallPageWithContext;